import { alpha, Box, styled } from "@mui/material";

export const style = {
  left: "50%",
  p: "1.5rem",
  position: "absolute" as "absolute",
  top: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "100vw",
    sm: "70vw"
  }
};


export const ModalContent = styled(Box)(({ theme }) => ({
  background: theme.customColors.backgroundCard,
  border: `2px solid ${ theme.customColors.border }`,
  borderRadius: "1rem",
  left: "50%",
  padding: "2rem",
  position: "relative",
  top: "50%",
  transform: "translate(-50%, -50%)",
  width: "65rem",
  maxWidth: "calc(100% - 4rem)",
  maxHeight: "calc(100% - 4rem)",
  overflowY: "auto",
 
  "::-webkit-scrollbar": {
    width: "0.44rem",
    backgroundColor: `${alpha(theme.customColors.exploreCardText, 0.2)}`,
    borderRadius: "0.5rem"
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: `${alpha(theme.customColors.exploreCardText, 0.2)}!important`,
    borderRadius: "0.5rem"
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: `${alpha(theme.customColors.exploreCardText, 1)}!important`,
    borderRadius: "0.5rem"
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    height: "100%",
    padding: "1rem",
    maxWidth: "calc(100% - 1rem)",
    maxHeight: "calc(100% - 1rem)"
  }
  
}));
